import { useEffect, useState } from 'react';
import api from '../config/axiosConfig';

// El catálogo ya no se hardcodea aquí — el backend (RequiredDocumentType.java) es la
// única fuente de verdad, servida en GET /api/document-types. Este módulo solo cachea
// la respuesta en memoria para no volver a pedirla en cada componente.
let cachedCategories = null;
let inFlightPromise = null;

export async function fetchDocumentCategories() {
  if (cachedCategories) return cachedCategories;
  if (inFlightPromise) return inFlightPromise;

  inFlightPromise = api.get('/document-types')
    .then((res) => {
      cachedCategories = res.data || [];
      return cachedCategories;
    })
    .finally(() => { inFlightPromise = null; });

  return inFlightPromise;
}

/**
 * Hook de conveniencia: expone { categories, loading }. `categories` empieza en []
 * hasta que resuelve el fetch (o el cache ya cargado de una llamada previa).
 */
export function useDocumentCategories() {
  const [categories, setCategories] = useState(cachedCategories || []);
  const [loading, setLoading] = useState(!cachedCategories);

  useEffect(() => {
    let active = true;
    fetchDocumentCategories().then((cats) => {
      if (active) {
        setCategories(cats);
        setLoading(false);
      }
    }).catch((err) => {
      // Sin servidor: catálogo vacío; la pantalla muestra su propio "Sin conexión". La siguiente
      // pantalla que lo pida lo vuelve a intentar (no se cachea el fallo).
      console.error('No se pudo cargar el catálogo de documentos:', err);
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, []);

  return { categories, loading };
}
